/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';

import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import { useLazyQuery } from '@apollo/client';
import getTrialBalance from '../../graphql/query/getTrialBalance';
import _ from 'lodash';
import { moneyFormatEmpty } from '../../Shared/colorFormat';
import { BalanceReportPrint } from '../../print/BalanceReportPrint';
import { useReactToPrint } from 'react-to-print';
import PrintIcon from '@material-ui/icons/Print';
import { useWindowDimensions } from '../../hooks';
import { downloadCSVFile } from '../../common';
import MyIcon from '../components/MyIcon';

const full = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
const mizania = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const arbah = [13, 14, 15];

export const renderAccountCell = (d: any, xs: any, p = 10, bold?: any) => (
  <Grid item xs={xs}>
    <Typography style={{ padding: p, fontWeight: bold }}>{d}</Typography>
  </Grid>
);
export const renderAccountHeaderCell = (
  d: any,
  xs: any,
  p = 10,
  bgcolor = '#fff'
) => (
  <Grid item xs={xs}>
    <Typography
      style={{ padding: p, fontWeight: 'bold', backgroundColor: bgcolor }}
    >
      {d}
    </Typography>
  </Grid>
);

export const renderAccount = ({ pacc, isRTL, p = 10 }: any) => {
  const { accounts } = pacc;
  return (
    <Box style={{ backgroundColor: '#eee' }}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box style={{ backgroundColor: '#fff' }}>
            <Grid container spacing={0}>
              {accounts.map((acc: any) => {
                const { accCode, accName, accNameAr, rc, rd, items } = acc;
                const name = isRTL ? accNameAr : accName;
                const bold = items?.length > 0 ? 'bold' : undefined;
                return (
                  <>
                    <Grid item xs={12}>
                      <Divider></Divider>
                    </Grid>
                    {renderAccountCell(accCode, 1, p, bold)}
                    {renderAccountCell(name, 7, p, bold)}
                    {renderAccountCell(moneyFormatEmpty(rd), 2, p, bold)}
                    {renderAccountCell(moneyFormatEmpty(rc), 2, p, bold)}
                    {items?.length > 0 && (
                      <Grid item xs={12}>
                        <Grid container spacing={0}>
                          {renderAccountHeaderCell('', 1, 3)}
                          {renderAccountHeaderCell(
                            isRTL ? 'البند' : 'Item',
                            5,
                            3,
                            '#eee'
                          )}
                          {renderAccountHeaderCell(
                            isRTL ? 'مدين' : 'Debit',
                            1,
                            3,
                            '#eee'
                          )}
                          {renderAccountHeaderCell(
                            isRTL ? 'دائن' : 'Credit',
                            1,
                            3,
                            '#eee'
                          )}
                          {renderAccountHeaderCell('', 4, 3)}
                        </Grid>
                        {items?.map((item: any) => (
                          <Grid container spacing={0}>
                            {renderAccountCell('', 1, 3)}
                            {renderAccountCell(
                              isRTL ? item?.itemNameAr : item?.itemName,
                              5,
                              3
                            )}
                            {renderAccountCell(
                              moneyFormatEmpty(item.debit),
                              1,
                              3
                            )}
                            {renderAccountCell(
                              moneyFormatEmpty(item.credit),
                              1,
                              3
                            )}
                            {renderAccountCell('', 4, 3)}
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    <Box style={{ marginBottom: 10 }}></Box>
                  </>
                );
              })}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

// const getCash = (monthData: any) => {
//   if (!monthData) return [];
//   if (monthData?.length > 0) {
//     const sales = monthData.map((sdo: any) => {
//       const { _id, debit, credit, ...rest } = sdo;
//       const { accCode, day, month, year } = _id;
//       return {
//         ...rest,
//         day,
//         month,
//         year,
//         debit,
//         credit,
//         amount: debit - credit,
//         date: new Date(year, month - 1, day),
//         accCode,
//         _id: `${day}-${month}-${year}`,
//         accday: `${day}-${month}-${year}-${accCode}`,
//       };
//     });
//     if (sales) {
//       const daycash = _(sales)
//         .groupBy('accday')
//         .map((array) => ({
//           _id: array?.[0]?._id,
//           accCode: array?.[0]?.accCode,
//           accName: array?.[0]?.accName,
//           accNameAr: array?.[0]?.accNameAr,
//           opaccCode: array?.[0]?.opaccCode,
//           opaccName: array?.[0]?.opaccName,
//           opaccNameAr: array?.[0]?.opaccNameAr,
//           day: array?.[0]?.day,
//           month: array?.[0]?.month,
//           year: array?.[0]?.year,
//           date: array?.[0]?.date,
//           accday: array?.[0]?.accday,
//           count: _.sumBy(array, 'count'),
//           credit: _.sumBy(array, 'credit'),
//           amount: _.sumBy(array, 'amount'),
//           debit: _.sumBy(array, 'debit'),
//         }))
//         .orderBy('date')
//         .value();
//       return daycash ? daycash : [];
//     } else {
//       return [];
//     }
//   } else {
//     return [];
//   }
// };

export default function BudgetReport({
  isRTL,
  // words,
  start,
  end,
  theme,
  company,
}: // drawerWidth,
// accounts,
any) {
  const [cashflow, setCashflow] = useState([]);
  // const [byday, setByday] = useState(true);
  const [parentslist, setParentsList] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [pars, setPars] = useState(full);
  const [totals, setTotals] = useState(null);
  const [profit, setProfit] = useState<any>(null);
  const [report, setReport] = useState<any>('tb');

  const [isTime, setIsTime] = useState(true);
  const { width } = useWindowDimensions();

  const [getTB, tbData]: any = useLazyQuery(getTrialBalance, {
    fetchPolicy: 'cache-and-network',
  });

  const downloadCSVSubmit = ({ data, colnames, name }) => {
    downloadCSVFile(data, name, colnames);
  };

  useEffect(() => {
    const dd = tbData?.data?.['getTrialBalance']?.data;
    const cf = tbData?.data?.['getTrialBalance']?.message;
    if (cf) {
      const pcf = JSON.parse(cf);
      // const rowcash = getCash(pcf);
      if (!pcf || pcf?.length === 0) {
        setCashflow([]);
        return;
      }
      setCashflow(pcf);
    }
    if (dd) {
      const accs = JSON.parse(dd);
      const faccs = accs.filter(
        (acc: any) =>
          (acc?.credit !== 0 || acc?.debit !== 0) &&
          pars.includes(acc.parentcode)
      );
      const orderBycode = _.orderBy(faccs, 'code');
      setAccounts(orderBycode);
      const rfaccount = faccs.map((fa: any) => {
        const { credit, debit } = fa;
        const raseed = debit - credit;
        let rc = 0;
        let rd = 0;
        if (raseed > 0) {
          rd = raseed;
        } else {
          rc = -raseed;
        }
        return {
          ...fa,
          rd,
          rc,
        };
      });

      const profitaccounts = accs.filter(
        (acc: any) =>
          (acc?.credit !== 0 || acc?.debit !== 0) &&
          arbah.includes(acc.parentcode)
      );
      const rprofitaccounts = profitaccounts.map((fa: any) => {
        const { credit, debit } = fa;
        const raseed = debit - credit;
        let rc = 0;
        let rd = 0;
        if (raseed > 0) {
          rd = raseed;
        } else {
          rc = -raseed;
        }
        return {
          ...fa,
          rd,
          rc,
        };
      });

      const profitfilter = rprofitaccounts.filter(
        (rf: any) => rf.rd !== 0 || rf.rc !== 0
      );

      const profitrd = _.sumBy(profitfilter, 'rd');
      const profitrc = _.sumBy(profitfilter, 'rc');

      const profitrs = profitrd - profitrc;

      setProfit({
        credit: profitrc,
        debit: profitrd,
        raseedd: profitrs > 0 ? profitrs : 0,
        raseedc: profitrs < 0 ? -profitrs : 0,
      });

      const lfilter = rfaccount.filter((rf: any) => rf.rd !== 0 || rf.rc !== 0);

      const allrd = _.sumBy(lfilter, 'rd');
      const allrc = _.sumBy(lfilter, 'rc');
      const allrsd = allrd - allrc;

      const bsrd = allrd + profitrd;
      const bsrc = allrc + profitrc;
      const bsrsd = bsrd - bsrc;

      const graseed = report === 'bs' ? bsrsd : allrsd;

      setTotals({
        credit: report === 'bs' ? bsrc : allrc,
        debit: report === 'bs' ? bsrd : allrd,
        raseedd: graseed > 0 ? graseed : 0,
        raseedc: graseed < 0 ? -graseed : 0,
      });

      const gaccs = _(lfilter)
        .groupBy('parentcode')
        .map((array, key) => ({
          code: Number(key),
          parent: array[0]?.parent,
          parentAr: array[0]?.parentAr,
          credit: _.sumBy(array, 'credit'),
          debit: _.sumBy(array, 'debit'),
          accounts: array,
        }))
        .orderBy('code')
        .value();

      const rfparent = gaccs.map((fa: any) => {
        const { credit, debit } = fa;
        const raseed = debit - credit;
        let rcredit = 0;
        let rdebit = 0;
        if (raseed > 0) {
          rdebit = raseed;
        } else {
          rcredit = -raseed;
        }
        return {
          ...fa,
          rdebit,
          rcredit,
        };
      });

      setParentsList(rfparent);
    }
  }, [tbData, pars]);
  useEffect(() => {
    const variables = isTime ? { start, end } : {};
    getTB({ variables });
  }, [start, end, isTime]);

  const componentRef: any = useRef();
  const documentTitle =
    report === 'tb'
      ? isRTL
        ? 'ميزان المراجعة'
        : 'Trial Sheet'
      : report === 'is'
      ? isRTL
        ? 'قائمة الدخل'
        : 'Income Statment'
      : report === 'bs'
      ? isRTL
        ? 'الميزانية العمومية'
        : 'Balance Sheet'
      : '';
  const print = useReactToPrint({
    content: () => componentRef.current,
    documentTitle,
    removeAfterPrint: true,
  });
  return (
    <>
      <Box
        p={1}
        display="flex"
        style={{
          position: 'absolute',
          top: 40,
          left: isRTL ? 200 : undefined,
          right: isRTL ? undefined : 200,
          flexGrow: 1,
        }}
      >
        <Box>
          <Box display="flex">
            <Box style={{ padding: 7 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ padding: 7 }}
                    checked={isTime}
                    onChange={() => {
                      setIsTime(!isTime);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography
                    style={{
                      color: theme.palette.primary.main,
                      fontWeight: 'bold',
                    }}
                  >
                    {isRTL ? 'تفعيل التاريخ' : 'Activate Date'}
                  </Typography>
                }
                style={{ fontSize: 14 }}
              />
            </Box>
          </Box>
        </Box>
        <Box style={{ marginLeft: 100, marginRight: 100 }}>
          <Button
            color="primary"
            variant={report === 'tb' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('tb');
              setPars(full);
            }}
            style={{ margin: 10, padding: 5, minWidth: 120 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'ميزان المراجعة' : 'Trial Sheet'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={report === 'is' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('is');
              setPars(arbah);
            }}
            style={{ margin: 10, padding: 5, minWidth: 120 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'قائمة الدخل' : 'Income Statment'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={report === 'bs' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('bs');
              setPars(mizania);
            }}
            style={{ margin: 10, padding: 5, minWidth: 120 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'الميزانية العمومية' : 'Balance Sheet'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={report === 'cash' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('cash');
            }}
            style={{ margin: 10, padding: 5, minWidth: 120 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'التدفقات المالية' : 'Cash Flow Statement'}
            </Typography>
          </Button>
          {/* {report === 'cash' && (
            <FormControlLabel
              control={
                <Checkbox
                  style={{ padding: 7 }}
                  checked={byday}
                  onChange={() => {
                    setByday(!byday);
                  }}
                  color="primary"
                />
              }
              label={
                <Typography
                  style={{
                    color: theme.palette.primary.main,
                    fontWeight: 'bold',
                  }}
                >
                  {isRTL ? 'تجميع باليوم' : 'Group by Day'}
                </Typography>
              }
              style={{ fontSize: 14 }}
            />
          )} */}
        </Box>
        <Box
          style={{
            position: 'absolute',
            left: isRTL ? 0 : undefined,
            right: isRTL ? undefined : 0,
            top: 15,
            zIndex: 112,
          }}
        >
          <IconButton onClick={print} title="Print Report" size="medium">
            <PrintIcon />
          </IconButton>
          <IconButton
            onClick={() =>
              downloadCSVSubmit({
                name: 'Download Sheet',
                data: accounts,
                colnames: [
                  'accCode',
                  'parent',
                  'parentAr',
                  'accName',
                  'accNameAr',
                  'debit',
                  'credit',
                  'balance',
                ],
              })
            }
            title="Download Sheet"
            size="medium"
          >
            <MyIcon icon="download" />
          </IconButton>
        </Box>
      </Box>
      <Box
        style={{
          width: width - 50,
          borderRadius: 25,
          overflow: 'auto',
          padding: 25,
        }}
      >
        {report === 'cash' && (
          <Grid container spacing={0}>
            {/* {renderAccountHeaderCell(isRTL ? 'التاريخ' : 'Date', 2, 10, '#eee')} */}
            {renderAccountHeaderCell(isRTL ? 'الرقم' : 'No', 2, 10, '#eee')}
            {renderAccountHeaderCell(
              isRTL ? 'الحساب' : 'Account',
              3,
              10,
              '#eee'
            )}
            {renderAccountHeaderCell(
              isRTL ? 'الحساب المقابل' : 'Opposite Account',
              3,
              10,
              '#eee'
            )}
            {renderAccountHeaderCell(isRTL ? 'مدين' : 'Debit', 2, 10, '#eee')}
            {renderAccountHeaderCell(isRTL ? 'دائن' : 'Credit', 2, 10, '#eee')}
            {cashflow.map((cf: any) => {
              return (
                <Grid container spacing={0}>
                  {renderAccountCell(cf.accCode, 2)}
                  {/* {renderAccountCell(covertToDate(cf.opTime), 2)} */}
                  {renderAccountCell(isRTL ? cf?.accNameAr : cf?.accName, 3)}
                  {renderAccountCell(
                    isRTL ? cf?.opaccNameAr : cf?.opaccName,
                    3
                  )}
                  {renderAccountCell(moneyFormatEmpty(cf.debit), 2)}
                  {renderAccountCell(moneyFormatEmpty(cf.credit), 2)}
                </Grid>
              );
            })}
          </Grid>
        )}
        {report !== 'cash' && (
          <Grid container spacing={0}>
            {renderAccountHeaderCell(isRTL ? 'الرقم' : 'No', 1, 10, '#eee')}
            {renderAccountHeaderCell(
              isRTL ? 'الحساب' : 'Account',
              7,
              10,
              '#eee'
            )}
            {renderAccountHeaderCell(isRTL ? 'مدين' : 'Debit', 2, 10, '#eee')}
            {renderAccountHeaderCell(isRTL ? 'دائن' : 'Credit', 2, 10, '#eee')}
          </Grid>
        )}
        {report !== 'cash' &&
          parentslist.map((pacc: any) => {
            return renderAccount({ pacc, isRTL });
          })}
        {report === 'bs' && (
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Divider></Divider>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={7}>
              <Typography style={{ padding: 10, fontWeight: 'bold' }}>
                {isRTL ? 'صافي ( الربح/الخسارة )' : 'Net Profit / Loss'}
              </Typography>
            </Grid>
            {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedd), 2)}
            {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedc), 2)}
          </Grid>
        )}

        {report !== 'cash' && (
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Divider></Divider>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={7}></Grid>
            {renderAccountHeaderCell(moneyFormatEmpty(totals?.debit), 2)}
            {renderAccountHeaderCell(moneyFormatEmpty(totals?.credit), 2)}
          </Grid>
        )}
        {report === 'is' && (
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Divider></Divider>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={7}>
              <Typography style={{ padding: 10, fontWeight: 'bold' }}>
                {isRTL ? 'صافي ( الربح/الخسارة )' : 'Net Profit / Loss'}
              </Typography>
            </Grid>
            {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedd), 2)}
            {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedc), 2)}
          </Grid>
        )}
        <Grid item xs={12}>
          <Box m={6}></Box>
        </Grid>
      </Box>
      <Box>
        <div style={{ display: 'none' }}>
          <BalanceReportPrint
            company={company}
            parentslist={parentslist}
            report={report}
            ref={componentRef}
            isRTL={isRTL}
            start={start}
            end={end}
            profit={profit}
            totals={totals}
            documentTitle={documentTitle}
            isTime={isTime}
          />
        </div>
      </Box>
    </>
  );
}
